<template>
  <section>
    <div class="content-box">
      <input
        ref="link_copy_box"
        v-model="link_url_copy"
        type="text"
        class="link_copy_box"
      >

      <!--没有历史链接的界面-->
      <div
        v-if="showNoContent"
        class="no-history"
      >
        <div class="empty_link" />
        <span>{{ $t('还没有创建过链接') }}</span>
        <div
          class="creatLink-group"
          @mouseenter="showLink=true;"
          @mouseleave="showLink=false;"
        >
          <span
            class="creatLink-btn"
            @click="showNewLink"
          >{{ $t('点击创建链接') }}</span>
          <ul
            v-show="(haveSecureDelivery||haveSmartshareDelivery) && showLink"
            class="createLink-options"
          >
            <li
              v-for="(item, index) in link"
              v-if="item.show"
              :key="index"
              :data-cmd="item.ref"
              :data-operate-type="item.operateType"
              @click="createLink($event, 0, true, item.ref)"
            >
              {{ $t('创建') }}{{ item.name }}
            </li>
          </ul>
        </div>
      </div>

      <!--含有历史链接的界面-->
      <div
        v-if="!showNoContent"
        class="delivery-items"
      >
        <div
          v-for="(item,index) in linkData"
          :key="item.code"
          class="delivery-item"
        >
          <!--判断smartshare则不显示-->
          <template v-if="item.is_smartshare!='1'">
            <div class="first-row">
              <!--名称-->
              <span
                class="instruction"
                :index="index"
                @click="createLink($event, index, false)"
              >{{ item.name }}</span>
              <!--安全链接icon-->
              <span
                v-if="item.security=='1'"
                class="icon-secure"
                style="font-size: 18px;"
              >
                <svg class="icon icon-i-operation">
                  <use xlink:href="#security-history" />
                </svg>
              </span>
              <!--smartShare icon-->
              <span
                v-if="item.is_smartshare=='1'"
                class="icon-smartshare"
                style="font-size: 18px;"
              >
                <svg class="icon icon-i-operation">
                  <use xlink:href="#sm-history" />
                </svg>
              </span>
              <!--右侧显示操作按钮-->
              <ul class="operations">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('复制')"
                  placement="top"
                  popper-class="tooltip-style-history"
                  :open-delay="500"
                >
                  <li @click="copyLink(index)">
                    <span
                      :index="index"
                      class="copyBtn operations-img"
                    >
                      <svg class="icon icon-i-operation">
                        <use xlink:href="#link-copy" />
                      </svg>
                    </span>
                  </li>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('编辑')"
                  placement="top"
                  popper-class="tooltip-style-history"
                  :open-delay="500"
                  :disabled="editBtnDisabled"
                >
                  <li @click="createLink($event, index ,false)">
                    <span
                      :index="index"
                      class="editBtn operations-img"
                    >
                      <svg class="icon icon-i-operation">
                        <use xlink:href="#link-edit" />
                      </svg>
                    </span>
                  </li>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('删除')"
                  placement="top"
                  popper-class="tooltip-style-history"
                  :open-delay="500"
                >
                  <li @click="deleteLink(index)">
                    <span
                      :index="index"
                      class="deleteBtn operations-img"
                    >
                      <svg class="icon icon-i-operation">
                        <use xlink:href="#link-del" />
                      </svg>
                    </span>
                  </li>
                </el-tooltip>
              </ul>
            </div>

            <!--展示部分-->
            <div class="second-row">
              <span class="status-group">
                <span class="status-label">{{ $t('状态：') }}</span><span class="link_status"><span
                  class="status"
                  :style="{backgroundColor:item.color}"
                />{{ item.status }}</span>
              </span>
              <span class="expire-group">
                <span class="expire-label">{{ $t('有效期：') }}</span><span class="expire_range">{{ item.expire_range }}</span>
              </span>
              <span class="range-group">
                <span class="range-label">{{ $t('范围：') }}</span><span class="link_range">{{ item.link_range }}</span>
              </span>
            </div>

            <!--分享数据的统计-->
            <div class="third-row">
              <span
                v-if="item.is_smartshare !== 1"
                class="download-group"
              >
                <span class="download_label">{{ $t('已下载次数：') }}</span><span class="already_download">{{ item.counter_download }} {{ $t('次') }}</span>
              </span>
              <span
                v-if="item.is_smartshare == 1"
                class="download-group"
              >
                <span class="download_label">{{ $t('访问人数：') }}</span><span class="already_download">{{ item.visitPeople>99?'99+':item.visitPeople }} {{ $t('次') }}</span>
              </span>
              <span class="authers-group">
                <el-tooltip
                  class="item"
                  popper-class="tooltip-style-history"
                  effect="dark"
                  :content="item.auth"
                  placement="top"
                  :open-delay="500"
                >
                  <span class="authers">{{ $t('权限：') }}<span style="color:#4D5365">{{ item.auth }}</span></span>
                </el-tooltip>
              </span>
              <div
                v-if="item.type !== 'dir' && item.mirror_version === 1"
                class="fourth-row"
              >
                <span class="milestone-group">
                  <span class="milestone-label">{{ $t('版本标记：') }}</span><span
                    class="milestone"
                    :title="item.milestone_desc"
                  >{{ item.milestone_desc }}</span>
                </span>
                <span class="comment-group">
                  <span class="comment">{{ $t('版本说明：') }}<span
                    style="color:#4D5365"
                    :title="item.comment"
                  >{{ item.comment }}</span></span>
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!--历史记录底部-->
    <div
      v-if="!showNoContent"
      class="link-history-footer"
    >
      <div
        class="create-link-group"
        @mouseenter="showLink=true;"
        @mouseleave="showLink=false;"
      >
        <ul
          v-show="showLink"
          class="create-link-options"
          :style="{top:haveSecureDelivery?haveSmartshareDelivery?'-110px':'-64px':'-64px'}"
        >
          <li
            v-for="(item, index) in link"
            v-if="item.show"
            :key="index"
            :data-cmd="item.ref"
            :data-operate-type="item.operateType"
            @click="createLink($event, 0, true, item.ref)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- 创建新的链接 -->
        <span
          class="create-link"
          @click="showNewLink"
        >{{ $t('创建新链接') }}</span><i
          v-show="haveSecureDelivery"
          class="icon icon-dropup"
        />
      </div>
      <span
        class="clear-all"
        @click="deleteLink"
      >{{ $t('全部清除') }}</span>
    </div>
    <lowBrowserCopy
      :copy-text="copyText"
      :visible.sync="lowBDialog"
    />
  </section>
</template>

<script>
// 参数
import store from 'store'
import * as Util from 'util/util'
import { RICH_TXT_COPY } from './rich-text-copy.js' // 复制组件的混入
import { isLinkOdc } from '../index.js'
import lowBrowserCopy from './lowBrowserCopy'
// 引入
const { getData, postData } = require('js/api/getdata').default

export default {
  name: 'Mgdelivery',
  components: {
    lowBrowserCopy,
  },
  mixins: [RICH_TXT_COPY],
  props: {
    otherData: Object,
    default: () => ({}),
  },
  data() {
    return {
      // 外链历史数量
      linkDataTemp: [], // 外链历史条目数量原始数据
      linkData: '', // 外链格式化后的历史数据

      // 顶部没有历史链接记录部分显示需要的参数
      showLink: false, // 是否显示安全链接普通链接的选择框
      link: [ // 显示可创建的外链历史类型
        {
          ref: 'commonLink',
          name: this.$t('普通链接'),
          operateType: 1,
          code: 1,
          vm: this,
          get show() {
            return true
          },
        },
        {
          ref: 'secureLink',
          name: this.$t('安全链接'),
          operateType: 1,
          code: 2,
          vm: this,
          get show() {
            const { vm } = this
            return vm.haveSecureDelivery
          },
        },
        {
          ref: 'smartShare',
          name: 'SmartShare',
          operateType: 1,
          code: 3,
          vm: this,
          get show() {
            const { vm } = this
            return vm.haveSmartshareDelivery
          },
        },
      ],
      isLoaded: false, // 第一次加载列表
      editBtnDisabled: false, // 控制编辑按钮tooltips显示隐藏

      // 全部类型的链接对象
      linkTypeAll: {
        name: this.$t('全部历史链接'),
        code: 0,
      },
      // 保存各种类链接数量
      countLinksNumObj: {
        normal: 0,
        security: 0,
        smartshare: 0,
        all: 0,
      },

      vm: this, // vmobj
      verIndex: null, // 历史分享版本索引
      noHistory: false, // 没有历史
      // 其他
      linkUrl: {}, // 链接地址
      link_url_copy: '', // 复制链接地址
      param: { // 默认请求参数
        neid: '',
        offset: '',
        limit: '',
        _: Date.parse(new Date()),
        account_id: 97,
        uid: '',
      },
    }
  },
  computed: {
    /**
             * 判断是否有安全链接权限
             */
    haveSecureDelivery() {
      const selectedData = this.otherData && this.otherData.meta
      const { security_delivery } = store.getters.accountConfig
      const { is_dir, path_type } = selectedData
      return path_type === 'ent' && security_delivery == '2' && !is_dir
    },
    /**
             * 断是否有smartshare
             */
    haveSmartshareDelivery() {
      return false // 暂时不做
      // let selectedData = this.otherData && this.otherData.meta,
      //     {smartshare_delivery} = store.getters.accountConfig,
      //     {is_dir,mime_type,path} = selectedData;
      // let canSmartshare = false;
      // if (mime_type === '' || mime_type === undefined) {
      //     canSmartshare = Util.canSmartshare(path);
      // } else {
      //     canSmartshare = Util.canSmartshare(mime_type);
      // }
      // return smartshare_delivery == '1' && !is_dir && canSmartshare;
    },
    /**
             * 当前文件对象
             */
    selectCurrentData() {
      return this.otherData && this.otherData.meta
    },
    /**
             * 是否显示没有链接分享历史界面
             */
    showNoContent() {
      return this.noHistory
    },
    /**
             * 设置选中的头部对象
             */
    selectTitleObj() {
      return this.$parent.selectTitleObj
    },
  },
  watch: {
    selectTitleObj(val) {
      this.param.type = val.code// type 0 全部链接 1普通 2安全 3smartshare
      this.linkHistory()
    },
  },
  created() {
    this.param.neid = this.otherData && this.otherData.meta && this.otherData.meta.neid
    this.param.account_id = store.getters.accountId
    this.param.uid = store.getters.uId
    this.param.type = 0// type 0 全部链接
    this.showLink = false // 默认不显示
    this.isLoaded = false// 重置 是否已经调用列表接口标识
    this.editBtnDisabled = false// 切换回来得时候重置编辑hover显示tooltip
    // 获取历史链接
    this.linkHistory()
  },
  destroyed() {
    // this.$parent.changeDropdownTitle(false,[]);
  },
  methods: {
    // +---------------------点击创建链接-------------------------
    createLink(e, index, isNew, name = 'commonLink') {
      if (!isNew) { // 在历史链接弹框点击编辑按钮、
        const { security, is_smartshare } = this.linkData[index]
        let isSmartShare = false
        let name = security == '1' ? 'secureLink' : 'commonLink'
        if (is_smartshare === 1) {
          name = 'smartShareDetail'
          isSmartShare = true
        }
        this.editBtnDisabled = true
        // 创建外链
        this.$emit(
          'create',
          name,
          this.selectCurrentData,
          isNew,
          {
            historyCode: this.linkData[index].code,
            isSmartShare,
          },
        )
        return
      }
      // let target = e.target || e.srcElement,
      //     name = Util.dataset(target).cmd
      if (e.button === 0) {
        isLinkOdc(this.selectCurrentData, true).then((res) => {
          if (res.isOdc) {
            window.$toast.simpleShow(res.errorInfo, 'warn')
          } else {
            // 创建外链
            this.$emit(
              'create',
              name,
              this.selectCurrentData,
              isNew,
            )
          }
        })
      }
    },
    // +---------------------点击复制链接-------------------------
    copyLink(index) {
      this.linkUrl = this.linkData[index].url
      this.deliveryInfo = this.linkData[index]
      this.isHistoryLink = true
      this.setRichTpl()
    },
    // +---------------------点击删除链接-------------------------
    deleteLink(index = null) { // 删除链接提示框
      const { vm } = this
      this.verIndex = index // 版本信息为空时清空历史链接
      // 清空弹框确定
      window.$confirm.show({
        value: true,
        isShow: true,
        onlyOne: false,
        title: '提示',
        isDescribe: true,
        describe: '删除链接, 会导致链接失效',
        content: '是否确认删除?',
        sure() {
          vm.confirmDelete()
          window.$confirm.hide()
        },
      })
    },
    confirmDelete() { // 清空弹框点击确认的回调
      const codes = []; const
        { vm } = this
      if (typeof (vm.verIndex) === 'number') {
        codes.push(this.linkData[vm.verIndex].code)
      } else {
        for (const item of this.linkData) {
          codes.push(item.code)
        }
      }
      const postdata = {
        codes,
        arrayFormat: true,
      }
      this.deleteCountLinkNum(codes)
      postData('deleteLink', postdata)
        .then((res) => {
          this.linkHistory()
          window.$toast.simpleShow('成功', 'success')
          if (typeof (vm.verIndex) === 'number') {
            const newData = { ...this.selectedData }
            const { index } = this.selectedData
            const len = this.linkData.length
            if (len > 1) {
              for (let i = 0; i < len; i++) {
                const v = this.linkData[i]
                if (vm.verIndex !== i) {
                  newData.delivery_code = v.delivery_code
                  break
                }
              }
            } else {
              delete newData.delivery_code
            }
            // 不需要刷新
            // this.$emit('refreshItem',{newData, index})
          } else {
            const newData = { ...this.selectedData }
            const { index } = this.selectedData
            delete newData.delivery_code

            // 不需要刷新
            // this.$emit('refreshItem',{newData, index})
          }
        }).catch((error) => {
          if (error.response) {
            const err = error.response.data
            window.$toast.simpleShow(err.message, 'warn')
          }
        })
    },
    // +---------------------显示可以创建的历史链接-----------------
    showNewLink() {
      if (this.haveSecureDelivery) return
      const data = { name: 'commonLink', operateType: '1' }
      isLinkOdc(this.selectCurrentData, true).then((res) => {
        if (res.isOdc) {
          window.$toast.simpleShow(res.errorInfo, 'warn')
        } else {
          // ??创建链接
          this.$emit('setCmd', data, { meta: this.selectCurrentData, isNew: true })
        }
      })
    },
    // +---------------------获取外链历史版本列表-----------------------------
    linkHistory() {
      getData('linkHistory', this.param).then((res) => {
        if (res.status == 200) {
          this.linkDataTemp = res.data
          this.getSmartshareLisHistoryVisitNum(res.data)
        } else {
          this.noHistory = false
        }
      }).catch((error) => {
        this.noHistory = true
        if (error.response) {
          const err = error.response.data
          this.showTips(err.message, 'warn')
        }
      })
    },
    // +-------------------------辅助函数列表-------------------------------
    // 获取smartshare浏览人数数据
    getSmartshareLisHistoryVisitNum(data) {
      const paramData = []
      if (data.length > 0) {
        for (const item of data) {
          // 是smartshare才会被添加如paramData
          if (item.is_smartshare === 1) {
            paramData.push(item.code)
          }
        }
      }
      if (paramData.length > 0) {
        postData('smartshareLisHistoryVisitNum', { bindId: paramData.toString() }).then((res) => {
          if (res.status == 200) {
            this.smartshareLinkVisitNumHandler(res.data.data)
          } else {
            // 如果接口出错传空数组
            this.smartshareLinkVisitNumHandler([])
          }
        }).catch((error) => {
          // 如果接口出错传空数组
          this.smartshareLinkVisitNumHandler([])
        })
      } else {
        this.smartshareLinkVisitNumHandler([])
      }
    },
    /**
             * 处理smartshare浏览人数数据
             */
    smartshareLinkVisitNumHandler(smartshareVisitNum) {
      if (smartshareVisitNum.length > 0) {
        // 有smartshare才进入
        for (const itemData of this.linkDataTemp) {
          // 是smartshare才进入循环
          if (itemData.is_smartshare === 1) {
            this.$set(itemData, 'visitPeople', 0)
            for (const itemVisit of smartshareVisitNum) {
              if (itemData.code === itemVisit.bindId) {
                this.$set(itemData, 'visitPeople', itemVisit.visit_people)
              }
            }
          }
        }
      }
      // 处理完smartshare visitnum数据在进行赋值
      this.linkData = this.linkDataTemp
      this.toFormatData(this.linkData)
      if (this.linkData.length > 0) {
        this.noHistory = false
        if (!this.isLoaded) {
          this.isLoaded = true
          this.countLinkHistory()
        }
      } else {
        this.noHistory = true
      }
    },
    // 解析参数为弹窗内需要的格式
    toFormatData(data) {
      for (let i = 0; i < data.length; i++) {
        this.linkData[i].status = ''
        this.linkData[i].color = ''

        if (data[i].approval == 1) {
          this.linkData[i].status = this.$t('审批中')
          this.linkData[i].color = '#FFAB27'
        }
        if (data[i].approval == 2) {
          this.linkData[i].status = this.$t('未通过审批')
          this.linkData[i].color = '#FF1B43'
        }
        if (data[i].approval == 0 || data[i].approval == 4) {
          if (data[i].delivery_expired) {
            this.linkData[i].status = this.$t('已失效')
            this.linkData[i].color = '#c6cdd7'
          } else {
            this.linkData[i].status = this.$t('使用中')
            this.linkData[i].color = '#7BDF92'
          }
        }

        this.linkData[i].link_range = ''
        if (data[i].only_staff == 1) {
          this.linkData[i].link_range = this.$t('仅内部成员可用')
        } else {
          this.linkData[i].link_range = this.$t('所有人可见')
        }

        this.linkData[i].expire_range = ''
        if (data[i].delivery_expired) {
          this.linkData[i].expire_range = this.$t('已过期')
        } else {
          this.linkData[i].expire_range = data[i].time_util + this.$t('天后过期')
        }

        this.linkData[i].milestone_desc = this.linkData[i].milestone_desc ? this.linkData[i].milestone_desc : this.$t('无')
        this.linkData[i].comment = this.linkData[i].comment ? this.linkData[i].comment : this.$t('无')

        this.linkData[i].auth = ''
        if (this.linkData[i].is_smartshare === 1) {
          if (this.linkData[i].receiver_setting === 1) {
            this.linkData[i].auth = this.$t('需要填写邮箱或手机号')
          } else if (data.receiver_setting === 2) {
            this.linkData[i].auth = this.$t('要求验证邮箱或手机号')
          } else {
            this.linkData[i].auth = this.$t('无需邮箱或手机号')
          }
          if (/^(rwp|wrp|rw|wr|rp|r)$/.test(data[i].mode)) {
            this.linkData[i].auth += ` / ${this.$t('下载')}`
          }
          if (data[i].has_password) {
            this.linkData[i].auth += ` / ${this.$t('加密')}`
          }
        } else {
          const downloadFlag = /^(rwp|wrp|rw|wr|rp|r)$/.test(data[i].mode)
          if (/^(rwp|wrp|rp|wp|p)$/.test(data[i].mode)) {
            this.linkData[i].auth += this.$t('允许预览')
          }
          if (downloadFlag) {
            this.linkData[i].auth += ` / ${this.$t('下载')}`
          }
          if (/^(rwp|wrp|rw|wr|wp|w)$/.test(data[i].mode)) {
            this.linkData[i].auth += ` / ${this.$t('上传')}`
          }
          if (data[i].has_password) {
            this.linkData[i].auth += ` / ${this.$t('加密')}`
          }
          if (downloadFlag) {
            if (data[i].rest_dl == -1) {
              this.linkData[i].auth += ` / ${this.$t('无限次下载')}`
            } else {
              this.linkData[i].auth += ` / ${this.$t('剩余可下载')}${data[i].rest_dl}${this.$t('次')}`
            }
          }
        }
      }
    },
    // 计算各个种类的链接的数量
    countLinkHistory() {
      this.countLinksNumObj = {
        normal: 0,
        security: 0,
        smartshare: 0,
        all: 0,
      }
      if (this.linkData.length > 0) {
        for (const item of this.linkData) {
          if (item.security === 1) {
            this.countLinksNumObj.security += 1
          } else if (item.is_smartshare === 1) {
            this.countLinksNumObj.smartshare += 1
          } else {
            this.countLinksNumObj.normal += 1
          }
        }
        this.countLinksNumObj.all = this.linkData.length
      }
      // 处理title数据，增加数量
      this.linkTypeAll.num = this.countLinksNumObj.all
      for (const item of this.link) {
        if (item.code === 1) { // 普通链接
          item.num = this.countLinksNumObj.normal
        } else if (item.code === 2) { // 安全链接
          item.num = this.countLinksNumObj.security
        } else if (item.code === 3) { // smartshare
          item.num = this.countLinksNumObj.smartshare
        }
      }
      // 暂时不处理这里...
      // this.$parent.changeDropdownTitle(true,[this.linkTypeAll,...this.link]);//boolean代表启用下拉框，第二参数是下拉数据
    },
    /**
             * @description 删除操作会改变title中的链接数量结算，当每次删除（包括全部清除操作）会调用这里找到删除对应的code将计算数更新
             */
    deleteCountLinkNum(codes) {
      for (const item of this.linkData) {
        if (codes.indexOf(item.code) !== -1) {
          if (item.security === 1) {
            this.countLinksNumObj.security -= 1
          } else if (item.is_smartshare === 1) {
            this.countLinksNumObj.smartshare -= 1
          } else {
            this.countLinksNumObj.normal -= 1
          }
        }
      }
      // 处理title数据
      let tempAllNum = 0
      for (const item of this.link) {
        if (item.code === 1) { // 普通链接
          item.num = this.countLinksNumObj.normal
        } else if (item.code === 2) { // 安全链接
          item.num = this.countLinksNumObj.security
        } else if (item.code === 3) { // smartshare
          item.num = this.countLinksNumObj.smartshare
        }
        tempAllNum += item.num
      }
      this.linkTypeAll.num = tempAllNum
      // this.$parent.changeDropdownTitleVal([this.linkTypeAll,...this.link]);//boolean代表启用下拉框，第二参数是下拉数据
    },
  },
}
</script>
<style lang="less">
.tooltip-style-history{
  background:#4D5365!important;
  .popper__arrow:after {
    border-top-color: #4D5365!important;
  }
}
</style>
<style scoped lang="less">
@import '~less/variable.less';
.content-box{
  padding: 24px;
  padding-top: 0;
  font-size: 14px;
  height: 450px;
  width: 520px;
  color: #4D5365;
  overflow-y: auto;
  box-sizing: border-box;
  // margin-bottom: 30px;
  border-top: 1px solid rgba(198,205,215,.4);
  .link_copy_box{
    opacity: 0;
    position: absolute;
    bottom: 0px;
    left: 0px;
  }
  .delivery-items{
    height: 397px;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      opacity: 0.6;
      background: #C1C7CD;
      border-radius: 100px;
    }
  }
}
.content-box::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.content-box::-webkit-scrollbar-thumb {
  opacity: 0.6;
  background: #C1C7CD;
  border-radius: 100px;
}
.first-row{
  height: 28px;
  line-height: 28px;
  padding-top: 20px;
  .instruction{
    cursor: pointer;
  }
  .instruction-img{
    width: 18px;
    height: 18px;
  }
  &:hover {
    .instruction{
      color: #0a64fa;
    }
  }
  .operations{
    .operations-img:hover{
      border-radius: 14px;
      background: #E8EBEF;
      float: left;
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }
}
.operations{
  float: right;
  height: 30px;
  width: 124px;
  li{
    float: left;
    margin-left: 12px;
  }
  .icon-border, .icon-content{
    font-size: 27px;
  }
  .operations-img{
    float: left;
    width: 28px;
    height: 28px;
    cursor: pointer;
    text-align: center;
    .icon-i-operation{
      width: 20px;
      height: 20px;
      display: inline-block;
    }
  }
}
.second-row{
  padding-top: 16px;
  .status-group, .expire-group, .range-group{
    width: 32%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    display: inline-block;
  }
  .range-group {
    width: 30%;
  }
  .status{
    display: inline-block;
    margin-right: 5px;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    vertical-align: middle;
  }
  .status-label, .expire-label, .range-label{
    padding-right: 8px;
    color: #929CA9;
  }
}
.third-row{
  padding-top: 12px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(198,205,215,0.4);
  .download-group {
    width: 32%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    display: inline-block;
    span>span{
      margin-left: 12px;
    }
  }
  .authers-group {
    display: inline-block;
    width: 67%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    span>span{
      margin-left: 14px;
    }
  }
  .download_label, .authers{
    color: #929CA9;
  }
  .milestone-group, .comment-group {
    display: block;
    margin-top: 12px;
    .milestone-label, .comment {
      color: #929ca9;
      span{
        width: 70%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        display: inline-block;
      }
    }
  }
}
.no-history{
  text-align: center;
  position: relative;
  & .empty_link{
    width: 130px;
    height: 130px;
    background: url("../source/nolink.svg") no-repeat;
    margin: 50px auto 30px;
  }
}
.creatLink-group{
  cursor: pointer;
  display: block;
  margin: 0px auto 0;
  text-align: center;
  width: 120px;
  & .creatLink-btn{
    text-align: center;
    width: 120px;
    height: 36px;
    line-height: 36px;
    background: @mainColor;
    border: none;
    color: #fff;
    border-radius: 2px;
    display: block;
    margin: 0 auto;
    margin-top: 18px;
    cursor: pointer;
  }
  & .createLink-options{
    width: 120px;
    border: 1px solid #DDDDDD;
    background: #fff;
    text-align: center;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.4), 0 1px 0 rgba(255, 255, 255, 0.5) inset;
    padding-top: 5px;
    padding-bottom: 5px;
    & li {
      padding: 5px 0;
    }
    & li:hover{
      background: rgba(198, 205, 215 ,0.4);
    }
  }
}
.link-history-footer{
  width: 100%;
  position: absolute;
  padding: 14px 0;
  bottom: 0;
  background: #fff;
  border-top: 1px solid rgba(198,205,215,.4);
  & .create-link-group {
    float: left;
    & .create-link-options {
      border: 1px solid #DDDDDD;
      position: absolute;
      background: #fff;
      left: 16px;
      bottom: 41px;
      min-width: 85px;
      text-align: center;
      padding: 5px 0;
      white-space: nowrap;
      color:#0a64fa;
      cursor:pointer;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.4), 0 1px 0 rgba(255, 255, 255, 0.5) inset;
      & li {
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
      }
      & li:hover {
        background: rgba(198, 205, 215 ,0.4);
      }
    }
    & i{
      position: relative;
      top: 3px;
    }
  }
  .create-link,.clear-all{
    color: #0a64fa;
    cursor: pointer;
  }
  .clear-all{
    padding-top: 5px;
    float: right;
    padding-right: 24px;
  }
  .create-link {
    padding-top: 5px;
    padding-left: 24px;
  }
}
</style>
